import React from 'react';
import styles from './Spinner.scss';
import Svg from 'rp-react-svg-icon';

function Spinner() {
  return (
    <div className={styles.root}>
      <Svg
        iconName="spinner"
        iconSize="2XL"
      />
    </div>
  );
}

export default Spinner;
